import React, {Component} from 'react';
import Alert from 'react-s-alert';
import Modal from 'react-modal';	
import firebase from 'firebase';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { sendLog } from '../../util'




const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	
  }
};


class ModalPerfiles extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
				paginas:[],
				paginasSeleccionadas:[],
				isActive:false		
		
		}
		
			
		//Referencia al nodo de perfiles de firebase
		this.PerfilesRef=database.ref().child('Perfiles');
		//Referencia al nodo de paginas de firebase
		this.PaginasRef=database.ref().child('Paginas');
		//Referencia al nodo de Accesos de firebase
		this.AccesosRef=database.ref().child('Accesos');
		
		//Función para crear los options del select de paginas o en este caso Accesos
		this.MakeItemsPaginas=this.MakeItemsPaginas.bind(this);
		
		//Monitorea el cambio del select de paginas o Accesos
		this.handleChange=this.handleChange.bind(this);
		
		//Función para eliminar un 
		this.handleClickEliminarPagina=this.handleClickEliminarPagina.bind(this);
		
		//Función para envio de formulario
		this.handleSubmit=this.handleSubmit.bind(this);
		
		//Función para renderizar la tabla de selecciones
		this.renderTable=this.renderTable.bind(this);
		
		this.toggleModal=this.toggleModal.bind(this);
		
	}
	
	componentWillMount(){
		
		
		
	}
	
	
	componentDidMount(){
		
		this.PaginasRef.on('value',this.gotData,this.errData);
		
	}
	
	
	
	
	gotData = (data) => {
		
		  let newPagina=[];
		  const paginasdata = data.val();
		  //Si el nodo de paginas no esta vacio (que no deberia de estarlo)
		  if(paginasdata!=null){
			  
			  const keys = Object.keys(paginasdata);
			
			  for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				newPagina.push({
					key:k,
					nombre:paginasdata[k].nombre,
					url:paginasdata[k].url,
					iconClass:paginasdata[k].iconClass
				  
				});
			  }
			 this.setState({paginas:newPagina});
			  
		  }
		
		}
		errData = (err) => {
	  console.log(err);
	}
	
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive,
			paginasSeleccionadas:[]
		});		
	}
	
	//Retorna las opciones para llenar el select de los perfiles
	MakeItemsPaginas(x){
		return <option key={x.key} >{x.nombre}</option>;		
	}
	
	handleChange(){
		
		let newPagina=[];		
		
		let pagina=this.state.paginas.find(pagina=> pagina.nombre===this.accesosPerfil.value);
		newPagina=this.state.paginasSeleccionadas.filter(pagina=>pagina.nombre!=this.accesosPerfil.value);
	
		newPagina.push({
			key:pagina.key,
			nombre:pagina.nombre,
			url:pagina.url,
			iconClass:pagina.iconClass
		})	
		this.setState({
			paginasSeleccionadas:newPagina
		})		
	}
	
	handleClickEliminarPagina(row){		
		this.setState({
			paginasSeleccionadas:this.state.paginasSeleccionadas.filter(paginas=>paginas.nombre!=row.nombre)			
		});	
	}
	
	btnEliminarFormatter(cell,row){
		
		
		return <p className="glyphicon glyphicon-remove btn-eliminar" onClick={() => {this.handleClickEliminarPagina(row)}} ></p>
	}
	
	
	
	handleSubmit(event){
	
		if(this.state.paginasSeleccionadas.length===0){
			
			Alert.error('Debes selecionar almenos un acceso para crear este perfil', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000
						
			});
			
		}
		else{
			
			let nombrePerfil=this.nombrePerfil.value;
		
			let key=this.PerfilesRef.push({
				
				nombre:nombrePerfil				
			});
					
			for(let i=0;i<this.state.paginasSeleccionadas.length;i++){
				
				this.AccesosRef.child(key.getKey()).push({
					nombre:this.state.paginasSeleccionadas[i].nombre,
					url:this.state.paginasSeleccionadas[i].url,
					iconClass:this.state.paginasSeleccionadas[i].iconClass
				})
			
				
			}
			
			sendLog({ tipo: 'perfil_nuevo', informacion_extra: {perfil: key.getKey()} });
			this.toggleModal();
			
		}
		
	
		
		
	
		event.preventDefault();
	}
	
	renderTable(){
	
		if(this.state.paginasSeleccionadas.length===0){
			
			return <center><p><b>Selecciona los accesos para este perfil</b></p></center>;
				
		}
		else{
			return(
			
				<BootstrapTable data={ this.state.paginasSeleccionadas}
					 ref='table'
					 pagination={ false }
					 search={ false }
					 hover
					 >
					<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
					<TableHeaderColumn dataField='nombre' dataSort={true}>Nombre de la pagina</TableHeaderColumn>
					<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEliminarFormatter.bind(this) }>Eliminar</TableHeaderColumn>					
				</BootstrapTable>		
					
			)
		}
		
		
	}
	
	render(){
		return(
		
			<div className="modal_perfiles">
			
				
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
					
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleSubmit}>
						
						
							<h4>Nuevo Perfil</h4>							
							<hr/>
							<div className="form-group">
								<label htmlFor="nombre_perfil">Nombre del perfil</label>
								<input type="text" required name="nombre_perfil" autoComplete="off" placeholder="Nombre del perfil"
								className="form-control"
								ref={input => {this.nombrePerfil=input;}}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Accesos</label>
								<select className="form-control"
								ref={input => {this.accesosPerfil=input;}}
								onChange={this.handleChange} defaultValue=" "
								>
									{this.state.paginas.map(this.MakeItemsPaginas)}
								</select>								
							</div>
							
							<div className="form-group">
									{this.renderTable()}
							</div>
			
							
						<hr/>
							
						<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
					</Modal> 
					
			</div>
		
		);
	}
	
}

export default ModalPerfiles;





// WEBPACK FOOTER //
// ./src/Components/Perfiles/ModalPerfiles.js